import { AxiosResponse } from 'axios';
import { IBooking } from '../Models/IBooking';
import ICreateGroupBooking from '../Models/ICreateGroupBooking';
import IUpdateVisitCheckoutSession from '../Models/IUpdateVisitCheckoutSession';
import IVisitCheckoutSession from '../Models/IVisitCheckoutSession';
import BaseApi from './BaseApi';

/**
 * The BookingsApi class.
 *
 */
class BookingsApi extends BaseApi {
	constructor() {
        super('bookings');
	}
	
	/** 
	 * Get bookings
	 *  
	 * @return {Promise} The request promise.
	*/
	public getBookings = (): Promise<AxiosResponse<IBooking[]>> => {		
		return this._get('', {});
	}
	
	/** 
	 * Get booking
	 *  
	 * @return {Promise} The request promise.
	*/
	public getBooking = (bookingId: string, email: string): Promise<AxiosResponse<IVisitCheckoutSession>> => {		
		return this._get(bookingId, {
			email
		});
	}

	/** 
	 * Update booking
	 *  
	 * @return {Promise} The request promise.
	*/
	public updateBooking = (booking: IUpdateVisitCheckoutSession): Promise<AxiosResponse<IVisitCheckoutSession>> => {		
		return this._post('update', booking);
	}
	/** 
	 * Get birthday bookings
	 *  
	 * @return {Promise} The request promise.
	*/
	public getBirthdayBookings = (): Promise<AxiosResponse<IBooking[]>> => {		
		return this._get('birthdays', {});
	}

	/* create group booking request */
	public createGroupBookingRequest = (request: ICreateGroupBooking): Promise<boolean> => this._post('groups', request)
	
	/* update group booking request */
	public updateGroupBookingRequest = (id: string, request: ICreateGroupBooking): Promise<boolean> => this._post(`groups/${id}`, request)
}

export default BookingsApi;